import React from 'react';
import { DashboardLayout } from '../components/dashboard/DashboardLayout';
import { PaymentHistory } from '../components/PaymentHistory';

export const PaymentHistoryPage: React.FC = () => {
  return (
    <DashboardLayout
      title="Payment History"
      subtitle="Complete ledger of all successful, pending, failed, and refunded membership transactions with real-time Firestore database sync."
    >
      <PaymentHistory viewMode="auto" showHeader={true} />
    </DashboardLayout>
  );
};
